<template>
  <page>
    <owner-sidebar slot="sidebar"/>
    <span slot="header">User Management</span>
    <b-tabs card no-fade>
      <b-tab title="Active" active>
        <active/>
      </b-tab>
      <b-tab title="Suspended">
        <suspended/>
      </b-tab>
      <b-tab title="Banned">
        <banned/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import page from '../../../templates/page'
import ownerSidebar from '../../../sidebar/owner'
import active from './active'
import suspended from './suspended'
import banned from './banned'

export default {
  components: {
    page,
    active,
    suspended,
    banned,
    ownerSidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/users/index.vue